import React, { useMemo } from 'react';
import { Avatar, Layout, Menu, Typography, Spin } from 'antd';
import FullScreenButton from 'src/components/common/FullScreenButton';
import { MenuUnfoldOutlined, MenuFoldOutlined, LogoutOutlined } from '@ant-design/icons';
import { useApolloClient } from '@apollo/client';
import ReturnToManagerBar from 'src/components/common/ReturnToManagerBar';

import { isLogedIn, userInfoVar, userVar } from 'src/apollo/cache';
import { USER_ME } from 'src/operations/queries/getUser';
import { useQueryProxy } from 'src/operations/proxy/user';
import { getCurrentToken } from '../../utils';
import { storage, useModal } from 'src/utils/hooks';

const { Header: HeaderWrapper } = Layout;
const { SubMenu } = Menu;
const { Text } = Typography;

const Header = ({ collapsed, onCollapse, isStatic = false }) => {
  const token = getCurrentToken();
  const client = useApolloClient();
  const { data } = useQueryProxy(USER_ME, { variables: { token } });

  const onLogout = () => {
    if (window.confirm('로그아웃 하시겠습니까?')) {
      isLogedIn(false);
      userInfoVar(null);
      client.clearStore();
      client.cache.gc();
      storage.removeItem('culp_token');
      window.location.reload();
    } else {
      return;
    }
  };

  const returnId = useMemo(() => {
    return window.localStorage.getItem('culp_return_id');
  }, []);

  const rightContent = (
    <>
      <Menu
        key="user"
        mode="horizontal"
        style={{ height: '100%', background: 'transparent', flex: 8, display: 'flex', justifyContent: 'flex-end', overflow: 'hidden' }}
      >
        <Menu.Item key="info">
          <FullScreenButton
            element={
              <img
                className="header-btn"
                src="/images/fullscreen_blue.png"
                alt="back arrow in header"
                style={{ cursor: 'pointer', width: '20px', height: '20px' }}
              />
            }
            activeElement={
              <img
                className="header-btn"
                src="/images/fullscreenExit_blue.png"
                alt="back arrow in header"
                style={{ cursor: 'pointer', width: '20px', height: '20px' }}
              />
            }
          />
        </Menu.Item>
        {/*  */}
        <SubMenu
          key="SubMenu"
          title={
            <>
              <Avatar

              //src="//image.zuiidea.com/photo-1487412720507-e7ab37603c6f.jpeg?imageView2/1/w/200/h/200/format/webp/q/75|imageslim"
              />
              <span style={{ color: '#000', marginLeft: 10 }}>
                <span className="username">
                  {data?.me?.name} <Text strong>({data?.me?.view_id})</Text>
                </span>
                <span onClick={onLogout} style={{ color: '#999', marginLeft: 20 }}>
                  로그아웃
                  <LogoutOutlined
                    style={{
                      marginLeft: 5,
                      verticalAlign: 'middle',
                      fontSize: 25,
                      color: '#ccc',
                    }}
                    key="logout"
                  />
                </span>
              </span>
            </>
          }
        >
          {/* <Menu.Item key="SignOut" onClick={onLogout}>
            <span>Sign out</span>
          </Menu.Item> */}
        </SubMenu>
      </Menu>
    </>
  );

  return (
    <>
      {returnId && <ReturnToManagerBar returnId={returnId} />}
      <HeaderWrapper
        isStatic={isStatic}
        style={{
          position: isStatic ? 'fixed' : 'relative',
          backgroundColor: '#e1efff',
          color: '#DEEBF7',
          fontSize: '40px',
          paddingLeft: 10,
          paddingRight: 10,
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ visibility: `${userInfoVar()?.level_test === 1 ? 'hidden' : 'visible'}`, flex: 1 }}>
          <div style={{ display: 'flex', height: '100%', alignItems: 'center' }}>
            {collapsed ? (
              <MenuFoldOutlined
                style={{
                  fontSize: 35,
                  color: '#000',
                }}
                className="trigger"
                onClick={onCollapse}
                color="#000"
              />
            ) : (
              <MenuUnfoldOutlined
                style={{
                  fontSize: 35,
                  color: '#000',
                }}
                className="trigger"
                onClick={onCollapse}
                color="#000"
              />
            )}
          </div>
        </div>
        {!isStatic ? <>{rightContent}</> : null}
      </HeaderWrapper>
    </>
  );
};

export default Header;
